module.exports = __webpack_public_path__ + "img/tofubowloben.90fd74ec.png";